import {UserFeedback} from 'src/openapi/models/UserFeedback';

export const sortUserFeedback = (
    userFeedback: UserFeedback[],
): UserFeedback[] => {
    return [...userFeedback.toSorted((a, b) => {
        return (b?.rating ?? 0) - (a?.rating ?? 0);
    })];
};
